import React from 'react';
import CustomerMyBusinessByCustomerDetail from './CustomerMyBusinessByCustomerDetail';
import { CRM_COMM_PAGE_ALL_BUSINESS_BY_CUSTOMER_DETAIL_QUOTES } from '../../utils/crmCommunicationTableColumns';

export default function CustomerAllBusinessByCustomerDetail(props) {
  return (
    <CustomerMyBusinessByCustomerDetail
      {...props}
      adminMode
      mode="quotes"
      listEndpointBase="/api/customer_evaluations/all_business/by_customer"
      detailEndpointPrefix="/api/customer_evaluations/my_customers"
      embeddedListPageKey={CRM_COMM_PAGE_ALL_BUSINESS_BY_CUSTOMER_DETAIL_QUOTES}
    />
  );
}
